'use client';

import { Dialog, DialogContent, DialogTitle } from '@/app/components/ui/dialog';
import type { UploadClawFileResult } from '../../../types';

interface DraftLocalPreviewDialogProps {
  file: UploadClawFileResult | null;
  onClose: () => void;
}

// quick-preview:// 附件没有真实 claw 路径，走不通 MediaBrowser，用远端 url 弹一个轻量 modal 顶替预览。
export const DraftLocalPreviewDialog = ({ file, onClose }: DraftLocalPreviewDialogProps) => {
  const open = !!file;
  const previewUrl = file?.preview_url;
  const fileName = file?.file_name || file?.file_path?.split('/').filter(Boolean).pop() || 'Preview';

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <DialogContent className="flex max-h-[90vh] w-auto max-w-[90vw] flex-col gap-3 border-system-white08 bg-[#181820] light:bg-white p-4 sm:max-w-[80vw]">
        <DialogTitle className="line-clamp-1 break-all light:text-[#121826] text-sm text-system-white">
          {fileName}
        </DialogTitle>
        <div className="flex max-h-[80vh] min-h-[200px] min-w-[280px] items-center justify-center overflow-hidden rounded-12 bg-system-white04 light:bg-[#F4F4FA]">
          {previewUrl && file?.file_type === 'image' && (
            <img alt={fileName} src={previewUrl} className="max-h-[80vh] max-w-full object-contain" />
          )}
          {previewUrl && file?.file_type === 'video' && (
            <video controls autoPlay src={previewUrl} className="max-h-[80vh] max-w-full">
              <track kind="captions" />
            </video>
          )}
          {previewUrl && file?.file_type === 'audio' && (
            <audio controls autoPlay src={previewUrl} className="w-[420px] max-w-full">
              <track kind="captions" />
            </audio>
          )}
          {(!previewUrl ||
            (file?.file_type !== 'image' && file?.file_type !== 'video' && file?.file_type !== 'audio')) && (
            <div className="px-6 py-10 text-center light:text-[rgba(18,24,38,0.6)] text-sm text-system-white40">
              {fileName}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
